import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './sitioweb/vistas/inicio/inicio.component';
import { ContactenosComponent } from './sitioweb/vistas/contactenos/contactenos.component';

const routes: Routes = [
  { path: '', component: InicioComponent },
  { path: 'contactenos', component: ContactenosComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
